import { useState, useRef } from 'react';
import { leftIcon, rightIcon } from '../utils/icons';
import Indicator from './Indicator';

const ImageSlider = ({ product }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = (e) => {
        const productWrapper = e.target.closest('.cardContainer');
        const currentProduct = e.target.closest('.swipe');
        if (currentProduct && productWrapper) {
            const wrapperRect = productWrapper.getBoundingClientRect();
            const productRect = currentProduct.getBoundingClientRect();
            if (wrapperRect.x === productRect.x) {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % product?.images.length);
            }
        }
    };

    const prevSlide = (e) => {

        const productWrapper = e.target.closest('.cardContainer');
        const currentProduct = e.target.closest('.swipe');

        if (currentProduct && productWrapper) {
            const wrapperRect = productWrapper.getBoundingClientRect();
            const productRect = currentProduct.getBoundingClientRect();

            if (wrapperRect.x === productRect.x) {
                setCurrentIndex((prevIndex) =>
                    prevIndex === 0 ? product?.images.length - 1 : prevIndex - 1
                );
            }
        }
    };
    const imgSource = product.images.length ? product?.images[currentIndex]?.src : product?.thumbnail?.src;
    const sliderRef = useRef();

    return (
        <div className='galleryArea' ref={sliderRef}>
            <Indicator product={product} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} />

            {product?.images?.length ? (
                <div className='leftIcon' onClick={prevSlide} onTouchStart={prevSlide}>
                    <div className='icon'>{leftIcon}</div>
                </div>
            ) : ''}

            <div className='galleryImages' style={{ backgroundImage: 'url(' + imgSource + ')' }}></div>

            {product?.images?.length ? (
                <div className='rightIcon' onClick={nextSlide} onTouchStart={nextSlide}>
                    <div className='icon'>{rightIcon}</div>
                </div>
            ) : ''}
        </div>
    );
};

export default ImageSlider;
